import React from "react";
import { HotkeysTarget2 } from "@blueprintjs/core";


function GenerateHK({generate}) {

    const hotkeys = [
        {
            combo: "g",
            global: true,
            label: "Generate",
            onKeyDown: generate,
        },
    ]

    return (
        <HotkeysTarget2 hotkeys={hotkeys}>
                {({ handleKeyDown, handleKeyUp }) => (
                    <div onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
                        
                    </div>
                )}
        </HotkeysTarget2>
    )
}

export default GenerateHK
